<div class="card" [id]="challenge().offerId">
  <div
    class="card-header"
    role="img"
    [style.height]="config().header.height"
    [style.backgroundImage]="config().header.backgroundImage.url | transformUrl"
    [title]="config().header.backgroundImage.bannerAriaLabel"
    [attr.aria-label]="config().header.backgroundImage.bannerAriaLabel"
  ></div>

  <div
    class="card-subheader"
    [class.card-subheader-completed]="challenge().isCompleted"
    [style.backgroundColor]="
      challenge().isCompleted
        ? config().subHeader.completedBackgroundColor
        : config().subHeader.backgroundColor
    "
  >
    <!-- Subheader Title -->
    @let labelConfig = config().subHeader.title;
    @if (labelConfig) {
      <p
        class="label"
        data-cy="frequency-card-subheader"
        [style.color]="labelConfig.color"
        [style.fontFamily]="labelConfig.fontFamily"
      >
        {{ labelConfig.label | replaceVars: challenge().target }}
      </p>
    }
  </div>

  <div
    class="card-content"
    data-variant="variant_11"
    data-cy="frequency-card-content"
  >
    <!-- Win Card -->
    @if (challenge().isCompleted) {
      <b2c-win-card class="win-container" [amount]="challenge().rewardRatio" />
    }

    @if (challenge().isSelected && challenge().progress < challenge().target) {
      <!-- Card Body -->
      <div class="card-body">
        <p
          class="minimum-spend-label"
          [style.color]="config().body.minimumSpendLabel.color"
          [style.fontFamily]="config().body.minimumSpendLabel.fontFamily"
          [innerHTML]="
            config().body.minimumSpendLabel.text
              | replaceVars: challenge().minAmountByTransaction
              | safe
          "
        ></p>

        <!-- Lacerta -->
        @let rewardRatioConfig = config().body.rewardRatio;
        @if (rewardRatioConfig) {
          <div
            class="reward-ratio-container"
            [style.color]="rewardRatioConfig.color"
            [style.fontFamily]="rewardRatioConfig.fontFamily"
            [style.backgroundColor]="rewardRatioConfig.backgroundColor"
          >
            <img
              [alt]="
                rewardRatioConfig.picture.alternativeText
                  | replaceVars: challenge().rewardRatio
              "
              [src]="rewardRatioConfig.picture.imageUrl"
              class="star-icon"
            />
            {{ rewardRatioConfig.text }}
            <span> {{ challenge().rewardRatio }} </span>
          </div>
        }

        <!-- Boreas -->
        @let earnLabelConfig = config().body.earnLabel;
        @if (earnLabelConfig) {
          <p
            class="earn-label"
            [style.color]="earnLabelConfig.color"
            [style.fontFamily]="earnLabelConfig.fontFamily"
            [style.backgroundColor]="earnLabelConfig.backgroundColor"
          >
            {{ earnLabelConfig.text }}<span>{{ challenge().rewardRatio }}</span>
            {{ earnLabelConfig.suffix }}
          </p>
        }

        <!-- Steps < 5 -->
        @if (challenge().target <= 5) {
          @let progressBarConfig = config().body.progressBar;
          <div class="stamps-wrapper">
            <div class="progress-container">
              <div
                class="progress-bar"
                [style.backgroundColor]="progressBarConfig.defaultColor"
              ></div>
              <div
                class="progress-bar-value"
                [style.width]="progressWidth()"
                [style.backgroundColor]="progressBarConfig.activeColor"
              ></div>
            </div>

            <div class="items" data-cy="stamps">
              @let steps = challenge().steps;
              @for (item of steps; track item) {
                <div class="item">
                  <img
                    [alt]="item"
                    data-cy="stamp"
                    class="responsive-width"
                    [src]="
                      item <= challenge().progress
                        ? config().body.stamps.iconSelected
                        : config().body.stamps.iconNonSelected
                    "
                  />
                  @if (config().body.stamps.showNumbers) {
                    <span
                      class="number"
                      [class.active]="item <= challenge().progress"
                      [class.current]="item === challenge().progress + 1"
                      [style.color]="
                        phase() === CampaignPhase.CURRENT &&
                        item === challenge().progress + 1
                          ? config().body.stamps.activeNumberColor
                          : config().body.stamps.nonActiveNumberColor
                      "
                      >{{ item }}</span
                    >
                  }
                </div>
              }
            </div>
          </div>
        } @else {
          <div class="visits-container">
            <span
              class="number"
              data-cy="progress"
              [style.borderColor]="
                challenge().progress > 1
                  ? config().body.visitsContainer.activeBorderColor
                  : config().body.visitsContainer.defaultBorderColor
              "
              >{{ challenge().progress }}</span
            >
            <span class="sign">/</span>
            <span
              class="number total"
              data-cy="target"
              [style.borderColor]="
                challenge().progress > 1
                  ? config().body.visitsContainer.activeBorderColor
                  : config().body.visitsContainer.defaultBorderColor
              "
              >{{ challenge().target }}</span
            >
          </div>
        }
      </div>

      <!-- Card Footer -->
      @let footerConfig = config().body.footer;
      @let remainingVisitsConfig = footerConfig.remainingVisitsLabel;
      @let canUnselect = challenge().canBeUnselected(phase());

      <ng-template #unselectButton>
        <b2c-unselection-button
          [phase]="phase()"
          [challenge]="challenge()"
          class="unselect-text"
          [isBisCampaign]="isBisCampaign()"
          [isEventChallenge]="isEventChallenge()"
        />
      </ng-template>

      @if (remainingVisitsConfig) {
        <div
          class="card-footer"
          [style.backgroundColor]="footerConfig.backgroundColor"
        >
          @if (canUnselect) {
            <ng-container [ngTemplateOutlet]="unselectButton" />
          }

          <p
            class="remaining-visits"
            [style.color]="remainingVisitsConfig.color"
            [style.fontFamily]="remainingVisitsConfig.fontFamily"
            [innerHTML]="
              remainingVisitsConfig.text | replaceVars: remainingVisits() | safe
            "
          ></p>
        </div>
      } @else if (canUnselect) {
        <ng-container [ngTemplateOutlet]="unselectButton" />
      }
    }

    <!-- Selection Button -->
    @if (!challenge().isSelected) {
      <div class="overlay">
        <b2c-selection-button
          b2cElement
          [phase]="phase()"
          [challenge]="challenge()"
          class="selection-button"
          [isBisCampaign]="isBisCampaign()"
          [isEventChallenge]="isEventChallenge()"
        />
      </div>
    }
  </div>
</div>
